import React, { useState, useEffect, useMemo } from "react";
import * as XLSX from "xlsx";
import Header from "./gapsy-header";
import Footer from "./gapsy-footer";
import styles from "../assets/css/gapsy-dashboard.module.css";
import { Livetabledata, RoleandMapping, rafmapping } from "../components/ApiProperty";
import tableStyles from '../assets/css/sharedTableStyles.module.css';
import { Modal } from 'react-bootstrap';
import { FaMinus, FaHandPointUp, FaHandPointDown } from "react-icons/fa";
import axios from 'axios';
import {
    Chart,
    ArcElement,
    Tooltip,
    Legend
} from "chart.js";

Chart.register(
    ArcElement,
    Tooltip,
    Legend
);

function GapsyCRODashboard() {

    const [excelData, setExcelData] = useState([]);
    const [dashboardData, setDashboardData] = useState({});
    const [rafData, setRafData] = useState([]);
    const [parameterMap, setParameterMap] = useState({});
    const [selectedParameter, setSelectedParameter] = useState("");
    const [watchlistParameter, setWatchlistParameter] = useState("");
    const [dashboardParameter, setDashboardParameter] = useState("");
    const [viewType, setViewType] = useState("dashboard");
    const chartRefs = React.useRef({});
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [detailRows, setDetailRows] = useState([]);
    const [detailTitle, setDetailTitle] = useState("");
    const [indicatorMapping, setIndicatorMapping] = useState([]);
    const [rafMap, setRafMap] = useState({});
    const [selectedFrequencyTab, setSelectedFrequencyTab] = useState("Daily");
    const [criticalityDateCounts, setCriticalityDateCounts] = useState({});
    const [selectedDate, setSelectedDate] = useState("");
    const [open, setOpen] = React.useState(false);

    const dept = sessionStorage.getItem("dept");

    const tabs = [
        { label: "Dashboard", value: "dashboard" },
        { label: "By Criticality", value: "criticality" },
        { label: "Trend by Date", value: "trend" },
        { label: "Treemap - Ownership", value: "ownership" },
        { label: "Trend Analysis", value: "parameterTrend" },
        { label: "Watchlist", value: "watchlist" }
    ];

    const normalize = (str) =>
        String(str || "")
            .toLowerCase()
            .replace(/–/g, "-")
            .replace(/\s+/g, " ")
            .trim();


    let csrfToken = sessionStorage.getItem("tokenizedSession");

    useEffect(() => {
        const fetchMappingData = async () => {

            try {
                const config = {
                    params: {
                        userId: localStorage.getItem('userid'),
                        dept: dept,
                        tableName: "all"
                    },
                    headers: {
                        'x-csrf-token': csrfToken,
                    },
                    withCredentials: true
                };

                const response = await axios.post(Livetabledata, {}, config);

                const result = response.data; // FIX

                // Flatten logic
                const flatData = result?.tables?.flatMap(table =>
                    table.records.map(record => ({
                        tableName: table.tableName,
                        ...record
                    }))
                ) || [];

                setExcelData(flatData);

            } catch (error) {
                console.error("Error fetching data:", error);
            }

        };

        fetchMappingData();

    }, []);

    useEffect(() => {

        const fetchRafMapping = async () => {
            try {
                const config = {
                    headers: {
                        userId: localStorage.getItem('userid'),
                        "x-csrf-token": csrfToken
                    },
                    withCredentials: true,
                    params: {
                        tableName: "all",
                        dept: dept
                    }
                };

                const response = await axios.post(rafmapping, {}, config);

                const apiresponse = response.data;

                console.log("RAF API response:", apiresponse);

                setRafData(apiresponse.data || []);

            } catch (error) {
                console.error("RAF mapping error:", error);
            }
        };

        if (csrfToken && dept) {
            fetchRafMapping();
        }

    }, [csrfToken, dept]);

    const fetchIndicatorMapping = async () => {
        try {
            const config = {
                params: {
                    adminId: localStorage.getItem('userid'),
                    tableName: "param_indicator"
                },
                headers: {
                    'x-csrf-token': csrfToken,
                },
                withCredentials: true
            };

            const response = await axios.post(RoleandMapping, {}, config);

            setIndicatorMapping(response.data.data || []);

        } catch (error) {
            console.error('Error fetching mapping!', error);
        }
    };

    useEffect(() => {
        fetchIndicatorMapping();
    }, []);

    useEffect(() => {
        if (!indicatorMapping.length) return;

        const map = {};

        indicatorMapping.forEach(item => {
            const param = item.PARAMETER_NAME;

            const indicators = item.RISK_INDICATOR
                ?.split(',')
                .map(i => i.trim())
                .filter(Boolean);

            map[param] = indicators;
        });

        setParameterMap(map);
        setSelectedParameter(Object.keys(map)[0] || "");
        setWatchlistParameter(Object.keys(map)[0] || "");
        setDashboardParameter(Object.keys(map)[0] || "");

    }, [indicatorMapping]);

    const toProperCase = (str) => {
        return String(str || "")
            .replace(/_/g, " ")
            .toLowerCase()
            .split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    };

    useEffect(() => {

        if (!rafData.length) return;

        const normalize = (str) =>
            String(str || "")
                .toLowerCase()
                .replace(/–/g, "-")
                .replace(/\s+/g, " ")
                .trim();

        const map = {};

        rafData.forEach(item => {
            map[normalize(item.RISK_INDICATOR)] = item.RISK_AREA;
        });

        setRafMap(map);

    }, [rafData]);


    const buildOwnershipCounts = (ownership) => {

        const rows = mergedData.filter(
            r => normalize(r.ownership) === normalize(ownership)
        );

        const groupedByDate = {};

        rows.forEach(row => {

            const date = row.date;

            if (!groupedByDate[date]) {
                groupedByDate[date] = {
                    green: [],
                    amber: [],
                    red: []
                };
            }

            if (row.status === "Green")
                groupedByDate[date].green.push(row);

            else if (row.status === "Amber")
                groupedByDate[date].amber.push(row);

            else
                groupedByDate[date].red.push(row);

        });

        return groupedByDate;
    };
    /* ---------------- INDICATOR CONFIG ---------------- */


    const getStatusFromValue = (value, indicator) => {

        const normalize = (str) =>
            String(str || "")
                .toLowerCase()
                .replace(/–/g, "-")
                .replace(/\s+/g, " ")
                .trim();

        const rafItem = rafData.find(r =>
            normalize(r.RISK_INDICATOR).includes(normalize(indicator))
        );

        if (!rafItem || value == null) return "";

        const val = Number(value);

        const lower = Number(rafItem.LOW_THRESHOLD);
        const min = Number(rafItem.MIN_THRESHOLD);
        const max = Number(rafItem.MAX_THRESHOLD);
        const upper = Number(rafItem.UPPER_THRESHOLD);
        const flag = Number(rafItem.BIG_BAD_FLAG);

        if (isNaN(val)) return "";

        //  BIG_BAD_FLAG = 0 → Higher is GOOD
        if (flag === 0) {

            if (val >= upper) return "Green";
            if (val <= lower) return "Red";
            if (val >= min && val <= max) return "Amber";

        }

        //  BIG_BAD_FLAG = 1 → Lower is GOOD (reverse)
        if (flag === 1) {

            if (val > upper) return "Red";
            if (val <= lower) return "Green";
            if (val >= min && val <= max) return "Amber";

        }

        return "Amber"; // fallback
    };


    const normalizeDate1 = (val) => {
        if (!val) return "";

        //  Handle Excel serial number
        const num = Number(val);
        if (!isNaN(num) && num > 20000) {
            const d = new Date((num - 25569) * 86400 * 1000);
            if (!isNaN(d.getTime())) {
                return d.toISOString().slice(0, 10);
            }
        }

        // Handle ISO or valid JS date
        let d = new Date(val);
        if (!isNaN(d.getTime())) {
            return d.toISOString().slice(0, 10);
        }

        //  Handle DD-MM-YYYY (VERY IMPORTANT for your case)
        if (typeof val === "string" && val.includes("-")) {
            const parts = val.split("-");
            if (parts.length === 3) {
                const [dd, mm, yyyy] = parts;
                d = new Date(`${yyyy}-${mm}-${dd}`);
                if (!isNaN(d.getTime())) {
                    return d.toISOString().slice(0, 10);
                }
            }
        }

        return ""; // fallback safe
    };

    /* ---------------- FORMAT FUNCTIONS ---------------- */

    const formatExcelDate = (excelDate) => {

        if (!excelDate) return "";

        // convert string numbers like "46112" → 46112
        const serial = Number(excelDate);

        if (isNaN(serial)) return excelDate;

        const date = new Date((serial - 25569) * 86400 * 1000);

        return date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "2-digit"
        });
    };

    const formatValue = (raw) => {

        if (raw === undefined || raw === null) return "";

        const value = String(raw);

        // if value already contains letters like mm, bn etc
        if (/[a-zA-Z]/.test(value)) {
            return value;
        }

        const num = Number(value);

        if (isNaN(num)) return value;

        return num.toFixed(2) + "%";
    };

    const getTrend = (current, previous) => {

        if (!current || !previous) return null;

        const c = Number(current["Current Value"]);
        const p = Number(previous["Current Value"]);

        //  handle missing / invalid
        if (c == null || p == null || isNaN(c) || isNaN(p)) {
            return null;
        }

        if (c > p) return "up";
        if (c < p) return "down";

        return "same"; // optional
    };

    const getColor = (status) => {
        if (!status) return "#e5e7eb";
        if (status === "Green") return "#00B050";
        if (status === "Amber") return "#FFC000";
        if (status === "Red") return "#FF0000";
        return "#e5e7eb";
    };

    const normalizeDate = (val) => {
        if (!val) return "";

        const num = Number(val);

        //  Excel serial
        if (!isNaN(num)) {
            const d = new Date((num - 25569) * 86400 * 1000);
            return d.toISOString().split("T")[0]; // YYYY-MM-DD
        }

        //  Already date string
        const d = new Date(val);
        if (!isNaN(d)) {
            return d.toISOString().split("T")[0];
        }

        return String(val).trim();
    };

    const getDetailRows = (level, date, status) => {

        return criticalityDateCounts?.[level]?.[date]?.[status.toLowerCase()] || [];

    };

    rafData.forEach(r => {
        rafMap[r.RISK_INDICATOR.trim()] = r;
    });

    const mergedData = excelData
        .map(row => {

            const mapping = rafMap[row.RISK_INDICATOR?.trim()];
            if (!mapping) return null;

            const value = Number(row.VALUE);

            const min = Number(mapping.MIN_THRESHOLD);
            const max = Number(mapping.MAX_THRESHOLD);
            const low = Number(mapping.LOW_THRESHOLD);
            const bigBad = mapping.BIG_BAD_FLAG === "1";

            let status = "";

            if (bigBad) {
                if (value >= min && value <= max) status = "Green";
                else if (value < min) status = "Amber";
                else status = "Red";
            } else {
                if (value >= min && value <= max) status = "Green";
                else if (value >= low && value < min) status = "Amber";
                else status = "Red";
            }

            const mergedRow = {
                indicator: row.RISK_INDICATOR,
                date: row.REPORTING_DATE,
                value,
                status,
                criticality: mapping.CRITICALITY_LEVEL,
                ownership: mapping.OWNERSHIP,
                riskArea: mapping.RISK_AREA,
                reviewCommittee: mapping.REVIEW_COMMITTEE
            };

            console.log("Merged Row", mergedRow);

            return mergedRow;

        })
        .filter(Boolean);

    console.log("Merged Data Final", mergedData);

    const parseExcelDate = (val) => {
        if (!val) return null;

        const num = Number(val);

        //  Excel serial
        if (!isNaN(num)) {
            return new Date((num - 25569) * 86400 * 1000);
        }

        //  Normal date string
        const d = new Date(val);
        if (!isNaN(d.getTime())) {
            return d;
        }

        return null;
    };

    const availableDates = React.useMemo(() => {

        const unique = new Set(
            mergedData.map(r =>
                new Date(parseExcelDate(r.date))
                    .toISOString()
                    .slice(0, 10)
            )
        );

        return Array.from(unique).sort((a, b) => new Date(b) - new Date(a)); // latest first

    }, [mergedData]);

    const validDates = React.useMemo(() => {

        if (!mergedData || !mergedData.length) return [];

        const dates = [
            ...new Set(
                mergedData.map(r =>
                    normalizeDate1(parseExcelDate(r.date))
                )
            )
        ];

        const result = dates.filter(date => {

            const filtered = mergedData.filter(r =>
                normalizeDate1(parseExcelDate(r.date)) === date
            );

            if (!filtered.length) return false;

            // STEP 1: unique indicators
            const uniqueMap = {};

            filtered.forEach(row => {
                const key = row.indicator?.toString().trim().toLowerCase();
                if (!uniqueMap[key]) {
                    uniqueMap[key] = row;
                }
            });

            const rows = Object.values(uniqueMap);

            // STEP 2: simulate chart logic
            const hasValidData = rows.some(row => {
                const status = getStatusFromValue(row.value, row.indicator);
                return status === "Red";
            });

            return hasValidData;
        });

        return result.sort((a, b) => new Date(b) - new Date(a));

    }, [mergedData]);

    useEffect(() => {
        if (validDates.length && !selectedDate) {
            setSelectedDate(validDates[0]);
        }
    }, [validDates]);

    const ownershipList = [...new Set(
        mergedData.map(r => r.ownership?.trim()).filter(Boolean)
    )];

    // trend by date logic

    const buildCriticalityDateCounts = () => {

        const levels = ["Level 1", "Level 2A", "Level 2B"];
        const result = {
            "Level 1": {},
            "Level 2A": {},
            "Level 2B": {}
        };

        levels.forEach(level => {

            //  STEP 1: Filter RAF indicators by frequency + level
            const selectedFreq = normalize(selectedFrequencyTab);

            const filteredIndicators = rafData
                .filter(r => normalize(r.MONITORING_FREQUENCY).includes(selectedFreq))
                .filter(r => normalize(r.CRITICALITY_LEVEL) === normalize(level))
                .map(r => normalize(r.RISK_INDICATOR));

            //  STEP 2: Filter mergedData based on above indicators
            let levelRows = mergedData.filter(r =>
                normalize(r.criticality) === normalize(level) &&
                filteredIndicators.includes(normalize(r.indicator))
            );

            //  fallback if filtering removes everything
            if (!levelRows.length) {
                levelRows = mergedData.filter(r =>
                    normalize(r.criticality) === normalize(level)
                );
            }

            //  group by indicator
            const indicatorMap = {};

            levelRows.forEach(row => {
                if (!indicatorMap[row.indicator]) {
                    indicatorMap[row.indicator] = [];
                }
                indicatorMap[row.indicator].push(row);
            });

            const dateCounts = {};

            Object.values(indicatorMap).forEach(rows => {

                const dateMap = {};

                rows.forEach(r => {
                    if (!dateMap[r.date]) {
                        dateMap[r.date] = [];
                    }
                    dateMap[r.date].push(r);
                });

                Object.entries(dateMap).forEach(([date, rowsArr]) => {

                    if (!dateCounts[date]) {
                        dateCounts[date] = {
                            green: [],
                            amber: [],
                            red: []
                        };
                    }

                    //  SAME STATUS LOGIC
                    let finalStatus = "green";

                    rowsArr.forEach(row => {

                        const status = getStatusFromValue(row.value, row.indicator)?.toLowerCase();

                        if (status === "red") finalStatus = "red";
                        else if (status === "amber" && finalStatus !== "red") {
                            finalStatus = "amber";
                        }

                    });

                    const baseRow = rowsArr[0];

                    const rafItem = rafData.find(r =>
                        normalize(r.RISK_INDICATOR) === normalize(baseRow.indicator)
                    );

                    const status = getStatusFromValue(baseRow.value, baseRow.indicator);

                    dateCounts[date][finalStatus].push({
                        "Risk Area": rafItem?.RISK_AREA || "",
                        "Risk Indicator": baseRow.indicator,
                        "Criticality": rafItem?.CRITICALITY_LEVEL || "",
                        "Ownership": rafItem?.OWNERSHIP || "",
                        "Current Value": baseRow.value,
                        "Current Status": status,
                        "date": date
                    });

                });

            });

            result[level] = dateCounts;

        });

        return result;
    };

    // Pie chart logic

    const buildCriticalityPeriodCounts = () => {

        const levels = ["Level 1", "Level 2A", "Level 2B"];

        const result = {
            current: {},
            previous: {},
            past: {}
        };

        levels.forEach(level => {

            const levelRows = mergedData.filter(
                r => r.criticality === level
            );

            // group by indicator
            const grouped = {};

            levelRows.forEach(row => {
                if (!grouped[row.indicator]) {
                    grouped[row.indicator] = [];
                }
                grouped[row.indicator].push(row);
            });

            const counts = {
                current: { green: [], amber: [], red: [] },
                previous: { green: [], amber: [], red: [] },
                past: { green: [], amber: [], red: [] }
            };

            Object.values(grouped).forEach(rows => {

                //  group by date
                const dateMap = {};

                rows.forEach(r => {
                    if (!dateMap[r.date]) {
                        dateMap[r.date] = [];
                    }
                    dateMap[r.date].push(r);
                });

                //  get sorted unique dates
                const sortedDates = Object.keys(dateMap)
                    .sort((a, b) => new Date(b) - new Date(a))
                    .slice(0, 3);   // only latest 3

                const periods = {
                    current: dateMap[sortedDates[0]] || [],
                    previous: dateMap[sortedDates[1]] || [],
                    past: dateMap[sortedDates[2]] || []
                };

                Object.entries(periods).forEach(([period, rowsArr]) => {

                    if (!rowsArr.length) return;

                    //  evaluate ONE final status per indicator per period
                    let finalStatus = "green";

                    rowsArr.forEach(row => {

                        const status = getStatusFromValue(row.value, row.indicator)?.toLowerCase();

                        if (status === "red") finalStatus = "red";
                        else if (status === "amber" && finalStatus !== "red") {
                            finalStatus = "amber";
                        }

                    });

                    const baseRow = rowsArr[0];

                    const rafItem = rafData.find(r =>
                        r.RISK_INDICATOR?.trim().toLowerCase() === baseRow.indicator?.trim().toLowerCase()
                    );

                    const status = getStatusFromValue(baseRow.value, baseRow.indicator);

                    counts[period][finalStatus].push({
                        "Risk Area": rafItem?.RISK_AREA || "",
                        "Risk Indicator": baseRow.indicator,
                        "Reporting Date": baseRow.date,
                        "Criticality": rafItem?.CRITICALITY_LEVEL || "",
                        "Ownership": rafItem?.OWNERSHIP || "",
                        "Current Value": baseRow.value,
                        "Current Status": status
                    });

                });

            });

            result.current[level] = counts.current;
            result.previous[level] = counts.previous;
            result.past[level] = counts.past;

        });

        return result;
    };

    const buildParameterTrend = () => {

        if (!selectedParameter || !parameterMap[selectedParameter]) return {};

        const indicators = parameterMap[selectedParameter].map(i =>
            normalize(i)
        );

        //  Step 1: filter mergedData
        const filtered = mergedData.filter(row =>
            indicators.includes(normalize(row.indicator))
        );

        //  Step 2: group by indicator first (important)
        const indicatorMap = {};

        filtered.forEach(row => {
            if (!indicatorMap[row.indicator]) {
                indicatorMap[row.indicator] = [];
            }
            indicatorMap[row.indicator].push(row);
        });

        const result = {};

        //  Step 3: process each indicator
        Object.entries(indicatorMap).forEach(([indicator, rows]) => {

            const rafItem = rafData.find(r =>
                normalize(r.RISK_INDICATOR) === normalize(indicator)
            );

            const riskArea = rafItem?.RISK_AREA || "Others";

            //  group by date
            const dateMap = {};

            rows.forEach(r => {
                const d = normalizeDate(r.date);

                if (!dateMap[d]) dateMap[d] = [];
                dateMap[d].push(r);
            });

            //  sort last 4 dates
            const sortedDates = Object.keys(dateMap)
                .sort((a, b) => new Date(b) - new Date(a))
                .slice(0, 4)
                .reverse();

            const trendRows = sortedDates.map(date => {

                const rowsArr = dateMap[date];

                const base = rowsArr[0];

                const value = base.value;

                const status = getStatusFromValue(value, indicator);

                return {
                    indicator,
                    riskArea,
                    date,
                    value,
                    status
                };
            });

            //  group by risk area
            if (!result[riskArea]) result[riskArea] = [];

            result[riskArea].push({
                indicator,
                data: trendRows
            });

        });

        return result;
    };

    const parameterTrendData = useMemo(() => {
        return buildParameterTrend();
    }, [selectedParameter, mergedData, rafData]);


    const getThresholdYAxis = (indicator) => {

        const normalize = (str) =>
            String(str || "")
                .toLowerCase()
                .replace(/–/g, "-")
                .replace(/\s+/g, " ")
                .trim();

        const rafItem = rafData.find(r =>
            normalize(r.RISK_INDICATOR).includes(normalize(indicator))
        );

        if (!rafItem) {
            return {
                labels: ["", "0", "0", "0"],
                values: [0, 0, 0]
            };
        }

        const low = Number(rafItem.LOW_THRESHOLD || 0);
        const min = Number(rafItem.MIN_THRESHOLD || 0);
        const max = Number(rafItem.MAX_THRESHOLD || 0);
        const upper = Number(rafItem.UPPER_THRESHOLD || 0);

        // TOP -> BOTTOM
        const labels = [
            "",
            max.toString(),
            low.toString(),
            "0"
        ];

        return {
            low,
            min,
            max,
            upper,
            labels
        };
    };

    const getZoneConfig = (indicator) => {

        const normalize = (str) =>
            String(str || "")
                .toLowerCase()
                .replace(/–/g, "-")
                .replace(/\s+/g, " ")
                .trim();

        const rafItem = rafData.find(r =>
            normalize(r.RISK_INDICATOR).includes(normalize(indicator))
        );

        const flag = Number(rafItem?.BIG_BAD_FLAG || 0);

        // BIG_BAD_FLAG = 0
        // Higher is GOOD
        // TOP = GREEN
        // MID = AMBER
        // BOT = RED

        if (flag === 0) {
            return {
                zones: ["green", "amber", "red"]
            };
        }

        // BIG_BAD_FLAG = 1
        // Lower is GOOD
        // TOP = RED
        // MID = AMBER
        // BOT = GREEN

        return {
            zones: ["red", "amber", "green"]
        };
    };

    const getYAxis = (indicators = []) => {

        const allValues = indicators.flatMap(ind =>
            ind.data.map(d => Number(d.value))
        );

        let min = Math.min(...allValues);
        let max = Math.max(...allValues);

        const range = max - min || 1;

        // round down & up properly
        min = Math.floor(min * 2) / 2;
        max = Math.ceil(max * 2) / 2;

        const step = (max - min) / 4;

        return { min, max, step };
    };

    const getYFromStatus = (
        value,
        status,
        yAxis,
        usableHeight,
        paddingTop,
        zoneConfig
    ) => {

        const totalHeight = usableHeight;
        const zoneHeight = totalHeight / 3;

        const innerPadding = 4;

        const low = Number(yAxis.low || 0);
        const max = Number(yAxis.max || 0);

        const overallMax = Math.max(
            max + ((max - low) || 10),
            value
        );

        const s = status?.toLowerCase().trim();

        const zoneIndex = zoneConfig.zones.indexOf(s);

        let start = 0;
        let end = overallMax;

        // -------------------------
        // THRESHOLD RANGES
        // -------------------------

        if (zoneConfig.zones[0] === "green") {

            // BIG_BAD_FLAG = 0
            // TOP GREEN
            // MID AMBER
            // BOT RED

            if (s === "red") {
                start = 0;
                end = low;
            }
            else if (s === "amber") {
                start = low;
                end = max;
            }
            else {
                start = max;
                end = overallMax;
            }

        } else {

            // BIG_BAD_FLAG = 1
            // TOP RED
            // MID AMBER
            // BOT GREEN

            if (s === "green") {
                start = 0;
                end = low;
            }
            else if (s === "amber") {
                start = low;
                end = max;
            }
            else {
                start = max;
                end = overallMax;
            }
        }

        // normalize INSIDE ZONE
        let ratio = (value - start) / ((end - start) || 1);

        ratio = Math.max(0, Math.min(1, ratio));

        const safeHeight = zoneHeight - (innerPadding * 2);

        // IMPORTANT:
        // smaller values at bottom
        // larger values at top INSIDE SAME ZONE

        const y =
            paddingTop +
            (zoneIndex * zoneHeight) +
            innerPadding +
            ((1 - ratio) * safeHeight);

        return y;
    };

    const [selectedOwnership, setSelectedOwnership] = useState(
        ownershipList.length ? ownershipList[0] : ""
    );

    useEffect(() => {
        if (ownershipList.length && !selectedOwnership) {
            setSelectedOwnership(ownershipList[0]);
        }
    }, [ownershipList]);

    useEffect(() => {

        if (viewType !== "criticality" || excelData.length === 0) return;

        const counts = buildCriticalityPeriodCounts();

        const periods = ["current", "previous", "past"];
        const levels = ["Level 1", "Level 2A", "Level 2B"];

        periods.forEach(period => {

            levels.forEach(level => {

                const key = `${period}_${level}`;
                const canvas = chartRefs.current[key];

                if (!canvas) return;

                const ctx = canvas.getContext("2d");

                if (canvas.chart) {
                    canvas.chart.destroy();
                }

                const data = counts[period][level];

                canvas.chart = new Chart(ctx, {

                    type: "pie",

                    data: {
                        labels: ["Green", "Amber", "Red"],
                        datasets: [{
                            data: [
                                data.green.length,
                                data.amber.length,
                                data.red.length
                            ],
                            backgroundColor: [
                                "#00B050",
                                "#FFC000",
                                "#FF0000"
                            ]
                        }]
                    },

                    options: {

                        animation: {
                            onComplete: function () {

                                const chart = this;
                                const ctx = chart.ctx;

                                ctx.font = "bold 12px Arial";
                                ctx.fillStyle = "white";
                                ctx.fontWeight = "bold";
                                ctx.textAlign = "center";
                                ctx.textBaseline = "middle";

                                chart.data.datasets.forEach((dataset, i) => {

                                    const meta = chart.getDatasetMeta(i);

                                    meta.data.forEach((element, index) => {

                                        const value = dataset.data[index];

                                        if (value === 0) return;   //  skip 0 values

                                        const position = element.tooltipPosition();

                                        ctx.fillText(value, position.x, position.y);

                                    });

                                });

                            }
                        },

                        plugins: {
                            legend: { display: false }
                        },

                        onClick: (event, elements) => {

                            if (!elements.length) return;

                            const index = elements[0].index;
                            const statusMap = ["green", "amber", "red"];

                            const selectedStatus = statusMap[index];
                            const rows = counts[period][level][selectedStatus];

                            const cap = (text) => text.charAt(0).toUpperCase() + text.slice(1);

                            setDetailRows(rows);
                            setDetailTitle(`${level} - ${cap(period)} - ${cap(selectedStatus)}`);
                            setShowDetailModal(true);
                        }
                    }
                });

            });

        });

    }, [viewType, excelData]);

    const selectedFrequency = selectedFrequencyTab || "Daily";

    const frequencies = [...new Set(
        rafData.map(r => r.MONITORING_FREQUENCY?.trim())
    )];

    useEffect(() => {
        if (viewType === "trend") {
            const counts = buildCriticalityDateCounts();
            setCriticalityDateCounts(counts);
        }
    }, [viewType, selectedFrequencyTab]);



    const buildWatchlistPieData = () => {

        if (!selectedDate) return {};

        const clean = (val) =>
            val ? val.toString().trim().toLowerCase() : "unknown";

        //  STEP 1: FILTER BY DATE
        const filtered = mergedData.filter(r =>
            normalizeDate1(parseExcelDate(r.date)) === normalizeDate1(selectedDate)
        );

        if (!filtered.length) return {};

        //  STEP 2: UNIQUE INDICATORS
        const uniqueMap = {};

        filtered.forEach(row => {
            const key = clean(row.indicator);

            if (!uniqueMap[key]) {
                uniqueMap[key] = row;
            }
        });

        const rows = Object.values(uniqueMap);

        console.log("SELECTED DATE:", selectedDate);

        console.log("FINAL FILTERED DATA:", rows);

        filtered.forEach(r => {
            console.log(
                "indicator:", r.indicator,
                "date:", normalizeDate1(parseExcelDate(r.date)),
                "riskArea:", r.riskArea,
                "status:", r.status
            );
        });

        console.log("TOTAL FILTERED:", filtered.length);

        const groupKeys = [
            { key: "riskArea", label: "Risk Area" },
            { key: "ownership", label: "Ownership" },
            { key: "reviewCommittee", label: "Review Committee" }
        ];

        const result = {};

        groupKeys.forEach(group => {

            const grouped = {};

            rows.forEach(row => {

                const category = clean(row[group.key]);

                if (!grouped[category]) {
                    grouped[category] = {
                        total: 0,
                        red: 0,
                        name: row[group.key]
                    };
                }

                grouped[category].total++;

                const status = getStatusFromValue(row.value, row.indicator);

                if (status === "Red") {
                    grouped[category].red++;
                }
                console.log(
                    "GROUP:",
                    group.label,
                    "CATEGORY:",
                    category,
                    "STATUS:",
                    getStatusFromValue(row.value, row.indicator)
                );
            });

            const percentData = Object.values(grouped)
                .map(val => ({
                    name: val.name,
                    percent: (val.red / val.total) * 100
                }))
                .filter(d => d.percent > 0)
                .sort((a, b) => b.percent - a.percent)
                .slice(0, 5);

            if (percentData.length > 0) {
                result[group.label] = percentData;
            }

        });

        return result;
    };

    const watchlistPieData = React.useMemo(() => {
        if (viewType !== "watchlist") return {};

        return buildWatchlistPieData();
    }, [viewType, selectedDate, mergedData]);

    const WatchlistPie = ({ title, data }) => {

        if (!data || data.length === 0) return null;

        const [hoverIndex, setHoverIndex] = React.useState(null);

        const cx = 160;
        const cy = 120;

        const rx = 95;
        const ry = 82;
        const depth = 0; //  depth factor for 3D effect

        const colors = [
            "#FF5252", // light red
            "rgb(230, 52, 52)", // coral red
            "#F44336", // red
            "#D32F2F", // dark red
            "#B71C1C"  // deep crimson
        ];

        const darkColors = [
            "#E57373",
            "#F44336",
            "#D32F2F",
            "#B71C1C",
            "#7F0000"
        ];


        // const normalizedData = data.filter(d => d.percent > 0);
        const total = data.reduce((sum, d) => sum + d.percent, 0);

        const normalizedData = data
            .filter(d => d.percent > 0)
            .map(d => ({
                ...d,
                drawPercent: total ? (d.percent / total) * 100 : 0
            }));

        const getPoint = (percent, scale = 1) => {
            const angle = (percent / 100) * 360 - 90;
            const rad = angle * Math.PI / 180;

            return {
                x: cx + rx * scale * Math.cos(rad),
                y: cy + ry * scale * Math.sin(rad)
            };
        };

        let cumulative = 0;

        const computed = normalizedData.map((d, i) => {
            const start = cumulative;
            cumulative += d.drawPercent;
            const end = cumulative;

            const largeArc = d.drawPercent > 50 ? 1 : 0;
            const mid = (start + end) / 2;
            const midRad = (mid / 100) * 2 * Math.PI;

            const offset = hoverIndex === i ? 16 : 0;
            const dx = Math.cos(midRad) * offset;
            const dy = Math.sin(midRad) * offset;

            const p1 = {
                ...getPoint(start, 1),
                x: getPoint(start, 1).x + dx,
                y: getPoint(start, 1).y + dy
            };

            const p2 = {
                ...getPoint(end, 1),
                x: getPoint(end, 1).x + dx,
                y: getPoint(end, 1).y + dy
            };

            return {
                ...d,
                i,
                start,
                end,
                mid,
                midRad,
                largeArc,
                dx,
                dy,
                p1,
                p2,
                isFront: Math.sin(midRad) > 0
            };
        });

        return (
            <div
                style={{
                    width: "360px",
                    padding: "12px",
                    borderRadius: "6px",
                    background: "#fff",
                    boxShadow: `
    0 6px 16px rgba(244,67,54,0.35),
    0 2px 6px rgba(183,28,28,0.25)
`,
                    border: "1px solid #F44336"
                }}
            >
                <div style={{ fontWeight: 600, marginBottom: 8, textAlign: "center" }}>
                    {title}
                </div>

                <svg width="340" height="240" style={{ overflow: "visible" }}>

                    {/*  SIDE WALLS FIRST */}
                    {computed.map(d => {
                        //  FIX: skip side wall for 100%
                        if (d.drawPercent === 100) return null;

                        if (!d.isFront) return null;

                        return (
                            <path
                                key={"side-" + d.i}
                                d={`
                                M ${d.p1.x} ${d.p1.y}
                                A ${rx} ${ry} 0 ${d.largeArc} 1 ${d.p2.x} ${d.p2.y}
                                L ${d.p2.x} ${d.p2.y + depth}
                                A ${rx} ${ry} 0 ${d.largeArc} 0 ${d.p1.x} ${d.p1.y + depth}
                                Z
                            `}
                                fill={darkColors[d.i % darkColors.length]}
                            />
                        );
                    })}

                    {/*  TOP SLICES */}
                    {computed.map(d => {
                        //  FIX: handle 100% slice
                        if (d.drawPercent === 100) {
                            return (
                                <ellipse
                                    key={"top-" + d.i}
                                    cx={cx}
                                    cy={cy}
                                    rx={rx}
                                    ry={ry}
                                    fill={hoverIndex === d.i ? "#d1343c" : colors[d.i]}
                                    stroke="#ffffffcc"
                                    strokeWidth="0.8"
                                    onMouseEnter={() => setHoverIndex(d.i)}
                                    onMouseLeave={() => setHoverIndex(null)}
                                />
                            );
                        }

                        return (
                            <path
                                key={"top-" + d.i}
                                d={`
                M ${cx + d.dx} ${cy + d.dy}
                L ${d.p1.x} ${d.p1.y}
                A ${rx} ${ry} 0 ${d.largeArc} 1 ${d.p2.x} ${d.p2.y}
                Z
            `}
                                fill={hoverIndex === d.i ? "#cf4148" : colors[d.i]}
                                stroke="#ffffffcc"
                                strokeWidth="0.8"
                                onMouseEnter={() => setHoverIndex(d.i)}
                                onMouseLeave={() => setHoverIndex(null)}
                            />
                        );
                    })}

                    {/*  LABELS LAST (always visible) */}
                    {computed.map(d => {
                        //  correct angle (VERY IMPORTANT FIX)
                        const angle = (d.mid / 100) * 360 - 90;
                        const rad = angle * Math.PI / 180;

                        const start = {
                            x: cx + rx * Math.cos(rad),
                            y: cy + ry * Math.sin(rad)
                        };

                        const elbowGap = 10; // small outward bend

                        const midPoint = {
                            x: cx + (rx + elbowGap) * Math.cos(rad),
                            y: cy + (ry + elbowGap) * Math.sin(rad)
                        };
                        //  label position (just after line)
                        const labelGap = 14;
                        const isRight = Math.cos(rad) >= 0;

                        const labelOffsetX = 25;

                        // KEY FIX: move top labels upward
                        const isTop = Math.sin(rad) < -0.3;
                        const isBottom = Math.sin(rad) > 0.3;

                        let labelOffsetY = 0;

                        if (isTop) {
                            labelOffsetY = -25;   // move up
                        } else if (isBottom) {
                            labelOffsetY = 10;    // slight down (optional)
                        }

                        const labelX = isRight
                            ? midPoint.x + labelOffsetX
                            : midPoint.x - labelOffsetX;

                        const labelY = midPoint.y + labelOffsetY;

                        const paddingX = 10;

                        const nameWidth = d.name.length * 5.5;
                        const percentWidth = (d.drawPercent.toFixed(0) + "%").length * 5.5;

                        const boxWidth = Math.max(nameWidth, percentWidth) + paddingX * 2;
                        const boxHeight = 28;


                        // correct box position
                        const boxX = isRight
                            ? labelX
                            : labelX - boxWidth;

                        const minX = 10;
                        const maxX = 340 - boxWidth - 10;

                        let finalBoxX = boxX;

                        // clamp inside container
                        if (finalBoxX < minX) finalBoxX = minX;
                        if (finalBoxX > maxX) finalBoxX = maxX;

                        const y = labelY;

                        //  where line should touch label
                        const edgeX = isRight ? finalBoxX : finalBoxX + boxWidth;

                        return (
                            <g key={"label-" + d.i}>
                                {/* connector with bend */}

                                <polyline
                                    points={`
        ${start.x},${start.y}
        ${midPoint.x},${midPoint.y}
        ${edgeX},${y}
    `}
                                    fill="none"
                                    stroke="#666"
                                    strokeWidth="1"
                                />
                                {/* label box */}
                                <rect
                                    x={finalBoxX}
                                    y={y - boxHeight / 2}
                                    width={boxWidth}
                                    height={boxHeight}
                                    fill={hoverIndex === d.i ? "#ffebee" : "#eee"}   //  highlight bg
                                    stroke={hoverIndex === d.i ? "#D32F2F" : "#bbb"} //  highlight border
                                    strokeWidth={hoverIndex === d.i ? "1.5" : "1"}
                                    rx="4"
                                />

                                {/* text */}
                                <text
                                    x={finalBoxX + boxWidth / 2}
                                    y={y - 3}
                                    fontSize="10"
                                    textAnchor="middle"
                                    fill={hoverIndex === d.i ? "#B71C1C" : "#000"} //  highlight text
                                >
                                    {d.name}
                                </text>

                                <text
                                    x={finalBoxX + boxWidth / 2}
                                    y={y + 9}
                                    fontSize="10"
                                    fontWeight="bold"
                                    textAnchor="middle"
                                    fill={hoverIndex === d.i ? "#B71C1C" : "#000"} //  highlight text
                                >
                                    {d.percent.toFixed(0)}%
                                </text>
                            </g>
                        );
                    })}
                </svg>
            </div>
        );
    };

    const filteredRaf = rafData.filter(r =>
        normalize(r.MONITORING_FREQUENCY) === normalize(selectedFrequency)
    );

    const getRiskArea = (indicator) => {
        const key = normalize(indicator);

        const found = Object.keys(rafMap).find(k =>
            k.includes(key) || key.includes(k)
        );

        return found ? rafMap[found] : "Unknown";
    };


    useEffect(() => {

        if (excelData.length === 0 || !dashboardParameter) return;

        const indicators = parameterMap[dashboardParameter] || [];

        const normalize = (str) =>
            String(str || "")
                .toLowerCase()
                .replace(/–/g, "-")
                .replace(/\s+/g, " ")
                .trim();

        const result = {};

        indicators.forEach(indicator => {

            const rows = excelData
                .filter(r =>
                    normalize(r.RISK_INDICATOR).includes(normalize(indicator))
                )
                .sort((a, b) =>
                    new Date(b.REPORTING_DATE) - new Date(a.REPORTING_DATE)
                );

            //  get unique dates only
            const uniqueRows = [];
            const seenDates = new Set();

            for (let r of rows) {
                if (!seenDates.has(r.REPORTING_DATE)) {
                    uniqueRows.push(r);
                    seenDates.add(r.REPORTING_DATE);
                }
                if (uniqueRows.length === 3) break; //  limit to 3
            }

            //  Map to your UI structure
            const mappedRows = uniqueRows.map(r => ({
                "Current Value": r.VALUE,
                "Current Status": getStatusFromValue(r.VALUE, indicator),
                "Reporting Date": r.REPORTING_DATE
            }));

            const current = mappedRows[0] || null;
            const previous = mappedRows[1] || null;
            const past = mappedRows[2] || null;

            const riskArea = getRiskArea(indicator); // already built

            result[indicator] = {
                riskArea,
                current,
                previous,
                past
            };

        });

        setDashboardData(result);

    }, [excelData, dashboardParameter, parameterMap, rafMap]);

    const groupedData = Object.entries(dashboardData).reduce((acc, [indicator, data]) => {

        if (!data) return acc;

        const area = data.riskArea || "Others";

        if (!acc[area]) acc[area] = [];

        acc[area].push({ indicator, data });

        return acc;

    }, {});
    /* ---------------- STYLES ---------------- */

    const sectionStyle = {
        border: "1px solid #2b6cb0",
        // marginBottom: "5px",
        padding: "15px",
        marginTop: "8px"
    };

    const formatRow = (row) => ({
        "Risk Area": row.riskArea || "",
        "Risk Indicator": row.indicator,
        "Reporting Date": row.date,
        "Criticality": row.criticality,
        "Ownership": row.ownership,
        "Current Value": row.value,
        "Current Status": row.status
    });

    const camelToTitle = (text = "") =>
        text
            .replace(/([A-Z])/g, " $1")        // space before capitals
            .replace(/\w\S*/g, w =>            // capitalize each word
                w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()
            )
            .trim();

    const allIndicators = Object.entries(parameterTrendData).flatMap(([area, indicators]) =>
        indicators.map(ind => ({
            ...ind,
            area
        }))
    );

    // const itemsPerRow = Math.min(allIndicators.length, 5);
    const gap = 10;
    const itemsPerRow = Math.min(allIndicators.length, 5);

    const cardWidth = `calc((100% - ${(itemsPerRow - 1) * gap}px) / ${itemsPerRow})`;
    console.log("DETAIL ROWS", detailRows);
    /* ---------------- RENDER ---------------- */

    return (

        <div
            className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}
            style={{
                backgroundImage: "none",
                backgroundColor: "#ffffff"
            }}
        >

            <Header />
            {/* <Navigation /> */}

            <main className="container-fluid">

                <div style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "8px",
                    padding: "6px",
                    // background: "#f8fafc",
                    borderRadius: "8px",
                    width: "fit-content",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.05)"
                }}>
                    {tabs.map((tab) => {
                        const isActive = viewType === tab.value;

                        return (
                            <div
                                key={tab.value}
                                onClick={() => setViewType(tab.value)}
                                style={{
                                    padding: "6px 14px",
                                    cursor: "pointer",
                                    fontSize: "12px",
                                    fontWeight: isActive ? "600" : "500",
                                    borderRadius: "2px",
                                    transition: "all 0.25s ease",

                                    background: isActive
                                        ? "linear-gradient(135deg, #2b6cb0, #4c8ed9)"
                                        : "transparent",

                                    color: isActive ? "#fff" : "#2b6cb0",

                                    boxShadow: isActive
                                        ? "0 2px 6px rgba(43,108,176,0.3)"
                                        : "none"
                                }}
                                onMouseEnter={(e) => {
                                    if (!isActive) {
                                        e.currentTarget.style.background = "#e6f0fa";
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (!isActive) {
                                        e.currentTarget.style.background = "transparent";
                                    }
                                }}
                            >
                                {tab.label}
                            </div>
                        );
                    })}
                </div>

                {/* <div className="card"> */}
                <div className="card-body">

                    <Modal
                        show={showDetailModal}
                        onHide={() => setShowDetailModal(false)}
                        backdrop="static"
                        keyboard={false}
                        size="xl"
                        style={{ marginTop: "12vh" }}
                    >
                        <Modal.Header
                            style={{
                                backgroundColor: "#366872",
                                color: "white",
                                padding: "0.5rem 1rem",
                            }}
                            closeButton
                        >
                            <Modal.Title style={{ fontSize: "16px" }}>
                                {detailTitle}
                            </Modal.Title>
                        </Modal.Header>

                        <Modal.Body style={{ padding: "0.75rem 1rem", fontSize: "14px" }}>

                            <div className="table-on-homepage-only">
                                <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
                                    <table
                                        className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`}
                                    >
                                        <thead>
                                            <tr>
                                                <th>Reporting Date</th>
                                                <th>Risk Area</th>
                                                <th>Risk Indicator</th>
                                                <th>Criticality</th>
                                                <th>Ownership</th>
                                                <th>Current Value</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>

                                        <tbody>

                                            {detailRows.map((row, i) => (

                                                <tr key={i}>

                                                    <td style={{ textAlign: "left" }}>
                                                        {formatExcelDate(
                                                            row["Reporting Date"] || row.date
                                                        ) || "-"}
                                                    </td>
                                                    <td style={{ textAlign: "left" }}>{row["Risk Area"] || "-"}</td>
                                                    <td style={{ textAlign: "left" }}>{row["Risk Indicator"] || "-"}</td>
                                                    <td style={{ textAlign: "left" }}>{row["Criticality"] || "-"}</td>
                                                    <td style={{ textAlign: "left" }}>{row["Ownership"] || "-"}</td>
                                                    <td style={{ textAlign: "left" }}>{formatValue(row["Current Value"]) || "-"}</td>

                                                    <td
                                                        style={{
                                                            textAlign: "left",
                                                            backgroundColor:
                                                                row["Current Status"] === "Green"
                                                                    ? "#00B050"
                                                                    : row["Current Status"] === "Amber"
                                                                        ? "#FFC000"
                                                                        : "#FF0000",
                                                            color: "white",
                                                            fontWeight: "bold"
                                                        }}
                                                    >
                                                        {row["Current Status"]}
                                                    </td>

                                                </tr>

                                            ))}

                                        </tbody>

                                    </table>
                                </div>

                            </div>

                        </Modal.Body>


                    </Modal>

                    {
                        viewType === "watchlist" && (

                            <div style={sectionStyle}>

                                <div
                                    className={`tableWrapper ${tableStyles.tableWrapper}`}
                                    style={{
                                        "maxHeight": "430px",   // or any value you want
                                        border: "none"
                                    }}
                                >
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between"
                                    }}>

                                        <h6 style={{ marginBottom: "5px" }}>

                                            Risk Indicator - Watchlist - Bad Performers

                                        </h6>

                                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                            <label
                                                style={{
                                                    fontSize: "12px",
                                                    fontWeight: "500",
                                                    marginBottom: "0",
                                                    whiteSpace: "nowrap",
                                                    marginRight: "0px"
                                                }}
                                            >
                                                Show By :
                                            </label>
                                            <div className="dropdown" style={{ minWidth: "100px" }}>
                                                <button
                                                    className="btn btn-light btn-sm dropdown-toggle w-100 text-start"
                                                    type="button"
                                                    data-bs-toggle="dropdown"
                                                    style={{
                                                        border: selectedParameter ? "1px solid #06090e" : "1px solid #ccc",
                                                        padding: "4px 8px",          //  reduced
                                                        fontSize: "12px",           //  smaller text
                                                        lineHeight: "1.2"
                                                    }}>
                                                    {selectedDate || "Select Date"}
                                                </button>

                                                <ul className="dropdown-menu w-100">

                                                    <div className={`tableWrapper ${tableStyles.tableWrapper}`}
                                                        style={{ maxHeight: "170px", overflowY: "auto", border: "none" }}
                                                    >

                                                        {validDates.map(date => (
                                                            <li key={date}>
                                                                <button
                                                                    className="dropdown-item"
                                                                    onClick={() => setSelectedDate(date)}
                                                                    style={{
                                                                        padding: "4px 8px",
                                                                        fontSize: "12px"
                                                                    }}
                                                                >
                                                                    {date}
                                                                </button>
                                                            </li>
                                                        ))}
                                                    </div>
                                                </ul>
                                            </div>
                                        </div>

                                    </div>


                                    <div style={{
                                        fontSize: "11px",
                                        marginBottom: "10px"
                                    }}>

                                        Displays {watchlistParameter} Bad Performers - By Risk Area, Ownership and Review Committee

                                    </div>


                                    <div style={{
                                        display: "flex",
                                        gap: "25px"
                                    }}>

                                        <WatchlistPie
                                            title="Risk Area"
                                            data={
                                                watchlistPieData["Risk Area"]
                                                || []
                                            }
                                        />


                                        <WatchlistPie
                                            title="Ownership"
                                            data={
                                                watchlistPieData["Ownership"]
                                                || []
                                            }
                                        />

                                        <WatchlistPie
                                            title="Review Committee"
                                            data={
                                                watchlistPieData["Review Committee"]
                                                || []
                                            }
                                        />

                                    </div>


                                    <div
                                        style={{
                                            fontSize: "10px",
                                            marginTop: "8px"
                                        }}
                                    >

                                        Note: Percentage figure displayed in the Chart is arrived based on the logic - Number of Risk Indicators in RED zone / Total Number of Risk Indicators of selected category

                                    </div>

                                </div>
                            </div>

                        )
                    }
                    {
                        viewType === "trend" && (
                            <div style={{
                                border: "1px solid #2b6cb0",
                                padding: "6px",
                                marginTop: "7px"
                            }}>
                                <div
                                    className={`tableWrapper ${tableStyles.tableWrapper}`}
                                    style={{
                                        "maxHeight": "420px",   // or any value you want
                                        border: "none"
                                    }}
                                >
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>

                                        <h6 style={{ marginBottom: "5px" }}>
                                            Risk Indicator Heatmap - By Criticality
                                        </h6>


                                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                            <label
                                                style={{
                                                    fontSize: "12px",
                                                    fontWeight: "500",
                                                    marginBottom: "0",
                                                    whiteSpace: "nowrap",
                                                    marginRight: "0px"
                                                }}
                                            >
                                                Show By :
                                            </label>
                                            <div className="dropdown" style={{ minWidth: "140px" }}>
                                                <button
                                                    className="btn btn-light btn-sm dropdown-toggle w-100 text-start"
                                                    type="button"
                                                    data-bs-toggle="dropdown"
                                                    style={{
                                                        border: selectedFrequencyTab ? "1px solid #06090e" : "1px solid #ccc",
                                                        padding: "4px 8px",
                                                        fontSize: "12px",
                                                        lineHeight: "1.2"
                                                    }}
                                                >
                                                    {selectedFrequencyTab || "Select Frequency"}
                                                </button>
                                                <ul className="dropdown-menu w-100">

                                                    <div className={`tableWrapper ${tableStyles.tableWrapper}`}
                                                        style={{ maxHeight: "150px", overflowY: "auto", border: "none" }}
                                                    >
                                                        {[...frequencies]
                                                            .map(f => f?.trim())
                                                            .filter(Boolean)
                                                            .sort((a, b) => a.localeCompare(b))
                                                            .map(freq => (
                                                                <li key={freq}>
                                                                    <button
                                                                        className="dropdown-item"
                                                                        onClick={() => setSelectedFrequencyTab(freq)}
                                                                        style={{
                                                                            padding: "4px 8px",
                                                                            fontSize: "12px"
                                                                        }}
                                                                    >
                                                                        {freq}
                                                                    </button>
                                                                </li>
                                                            ))}
                                                    </div>
                                                </ul>
                                            </div>

                                        </div>


                                    </div>


                                    {/* </div> */}
                                    <div style={{ fontSize: "11px", marginBottom: "10px" }}>
                                        Displays the number of Risk Indicators in Green, Amber and Red Zones.
                                    </div>
                                    {/* <div className="table-on-homepage-only"> */}
                                    <div
                                        className={`tableWrapper ${tableStyles.tableWrapper}`}
                                        style={{
                                            maxHeight: "none",
                                            height: "auto",
                                            overflow: "visible",
                                            overflowX: "visible",
                                            overflowY: "visible",
                                            border: "none"
                                        }}
                                    >
                                        <div className="table-on-homepage-only">
                                            <table
                                                className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`}
                                            >
                                                <thead>
                                                    <tr>
                                                        <th>Criticality</th>
                                                        <th>Date</th>
                                                        <th style={{ background: "#00B050" }}>Green</th>
                                                        <th style={{ background: "#FFC000" }}>Amber</th>
                                                        <th style={{ background: "#FF0000", color: "#fff" }}>Red</th>
                                                        <th>Trend</th>
                                                    </tr>
                                                </thead>

                                                <tbody>

                                                    {Object.entries(criticalityDateCounts || {}).map(([level, dates]) => {

                                                        if (!dates || Object.keys(dates).length === 0) return null;

                                                        const sortedDates = Object.entries(dates)
                                                            .sort((a, b) => {
                                                                const d1 = new Date(a[0]);
                                                                const d2 = new Date(b[0]);

                                                                if (isNaN(d1) || isNaN(d2)) return 0;

                                                                return d2 - d1;
                                                            }).slice(0, 4);

                                                        return sortedDates.map(([date, data], index) => {

                                                            const prev = sortedDates[index + 1];

                                                            let trendIcon = <FaMinus color="#FFC000" />;

                                                            const currentGreenCount = data.green.length;

                                                            // Previous date green count
                                                            const previousGreenCount = prev
                                                                ? prev[1]?.green?.length || 0
                                                                : currentGreenCount;

                                                            // Compare current vs previous
                                                            if (currentGreenCount > previousGreenCount) {
                                                                trendIcon = <FaHandPointUp color="#00B050" />;
                                                            }
                                                            else if (currentGreenCount < previousGreenCount) {
                                                                trendIcon = <FaHandPointDown color="#FF0000" />;
                                                            }
                                                            else {
                                                                trendIcon = <FaMinus color="#FFC000" />;
                                                            }
                                                            return (

                                                                <tr key={level + date}>

                                                                    {index === 0 && (
                                                                        <td rowSpan={sortedDates.length} style={{ fontWeight: "bold" }}>
                                                                            {level}
                                                                        </td>
                                                                    )}

                                                                    <td style={{ padding: "3px" }}>{formatExcelDate(date)}</td>

                                                                    <td style={{ padding: "3px" }}
                                                                        ref={(el) => {
                                                                            if (el) {
                                                                                el.style.setProperty("background-color", "#00B050", "important");
                                                                                el.style.setProperty("color", "#ffffff", "important");
                                                                                el.style.cursor = "pointer";
                                                                            }
                                                                        }}
                                                                        onClick={() => {

                                                                            if (data.green.length === 0) return;
                                                                            const rows = getDetailRows(level, date, "Green");

                                                                            setDetailRows(rows);
                                                                            setDetailTitle(`${level} - ${formatExcelDate(date)} - Green`);
                                                                            setShowDetailModal(true);

                                                                        }}
                                                                    >
                                                                        {data.green.length}
                                                                    </td>

                                                                    <td style={{ padding: "3px" }}
                                                                        ref={(el) => {
                                                                            if (el) {
                                                                                el.style.setProperty("background-color", "#FFC000", "important");
                                                                                el.style.setProperty("color", "#ffffff", "important");
                                                                                el.style.cursor = "pointer";
                                                                            }
                                                                        }}
                                                                        onClick={() => {

                                                                            if (data.amber.length === 0) return;
                                                                            const rows = getDetailRows(level, date, "Amber");

                                                                            setDetailRows(rows);
                                                                            setDetailTitle(`${level} - ${formatExcelDate(date)} - Amber`);
                                                                            setShowDetailModal(true);

                                                                        }}
                                                                    >
                                                                        {data.amber.length}
                                                                    </td>


                                                                    <td style={{ padding: "3px" }}
                                                                        ref={(el) => {
                                                                            if (el) {
                                                                                el.style.setProperty("background-color", "#FF0000", "important");
                                                                                el.style.setProperty("color", "#ffffff", "important");
                                                                                el.style.cursor = "pointer";
                                                                            }
                                                                        }}
                                                                        onClick={() => {

                                                                            if (data.red.length === 0) return;
                                                                            const rows = getDetailRows(level, date, "Red");

                                                                            setDetailRows(rows);
                                                                            setDetailTitle(`${level} - ${formatExcelDate(date)} - Red`);
                                                                            setShowDetailModal(true);

                                                                        }}
                                                                    >
                                                                        {data.red.length}
                                                                    </td>


                                                                    <td style={{ fontSize: "16px", textAlign: "center", padding: "3px" }}>
                                                                        {trendIcon}
                                                                    </td>

                                                                </tr>

                                                            )

                                                        })

                                                    })}

                                                </tbody>

                                            </table>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        )
                    }

                    {
                        viewType === "parameterTrend" && (

                            <>

                                <div style={{
                                    border: "1px solid #2b6cb0",
                                    padding: "6px",
                                    marginTop: "8px"
                                }}>
                                    <div
                                        className={`tableWrapper ${tableStyles.tableWrapper}`}
                                        style={{
                                            "maxHeight": "406px",   // or any value you want
                                            border: "none"
                                        }}
                                    >

                                        <div style={{ display: "flex", justifyContent: "space-between" }}>

                                            <h6 style={{ marginBottom: "5px" }}>
                                                Risk Indicator Trend Analysis
                                            </h6>

                                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                <label
                                                    style={{
                                                        fontSize: "12px",
                                                        fontWeight: "500",
                                                        marginBottom: "0",
                                                        whiteSpace: "nowrap",
                                                        marginRight: "0px"
                                                    }}
                                                >
                                                    Show By :
                                                </label>
                                                <div className="dropdown" style={{ minWidth: "180px" }}>
                                                    <button
                                                        className="btn btn-light btn-sm dropdown-toggle w-100 text-start"
                                                        type="button"
                                                        data-bs-toggle="dropdown"
                                                        style={{
                                                            border: selectedParameter ? "1px solid #06090e" : "1px solid #ccc",
                                                            padding: "4px 8px",          //  reduced
                                                            fontSize: "12px",           //  smaller text
                                                            lineHeight: "1.2"
                                                        }}
                                                    >
                                                        {selectedParameter || "Select Parameter"}
                                                    </button>

                                                    <ul className="dropdown-menu w-100">

                                                        <div className={`tableWrapper ${tableStyles.tableWrapper}`}
                                                            style={{ maxHeight: "150px", overflowY: "auto", border: "none" }}
                                                        >
                                                            {Object.keys(parameterMap).map(param => (
                                                                <li key={param}>
                                                                    <button
                                                                        className="dropdown-item"
                                                                        onClick={() => setSelectedParameter(param)}
                                                                        style={{
                                                                            padding: "4px 8px",
                                                                            fontSize: "12px"
                                                                        }}
                                                                    >
                                                                        {toProperCase(param)}
                                                                    </button>
                                                                </li>
                                                            ))}
                                                        </div>
                                                    </ul>
                                                </div>

                                            </div>
                                        </div>

                                        <div style={{ fontSize: "11px", marginBottom: "2px" }}>
                                            Displays the Trends of {camelToTitle(selectedParameter)} Risk Indicators.
                                        </div>
                                        {/* <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}> */}
                                        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                                            {allIndicators.map(ind => {

                                                // const yAxis = getThresholdYAxis(ind.indicator);
                                                const yAxis = getThresholdYAxis(ind.indicator);
                                                const zoneConfig = getZoneConfig(ind.indicator);

                                                const data = ind.data;

                                                return (
                                                    <div
                                                        key={ind.indicator}
                                                        style={{
                                                            flex: `0 0 ${cardWidth}`,
                                                            maxWidth: cardWidth,
                                                            border: "1px solid #ddd",
                                                            padding: "2px",
                                                            boxSizing: "border-box"
                                                        }}
                                                    >

                                                        {/*  RISK AREA */}
                                                        <div title={ind.area}
                                                            style={{
                                                                fontSize: "10px",
                                                                textAlign: "center",
                                                                marginBottom: "2px",
                                                                color: "#666",
                                                                cursor: "pointer"
                                                            }}>
                                                            {camelToTitle(ind.area)}
                                                        </div>

                                                        {/* Indicator Title */}
                                                        <div
                                                            title={ind.indicator} style={{
                                                                fontSize: "10px",
                                                                textAlign: "center",
                                                                // marginBottom: "5px",
                                                                fontWeight: "bold",
                                                                // height: "32px",              //  FIXED HEIGHT
                                                                overflow: "hidden",          //  hide overflow
                                                                display: "-webkit-box",
                                                                WebkitLineClamp: 2,          //  max 2 lines
                                                                WebkitBoxOrient: "vertical",
                                                                cursor: "pointer"
                                                            }}>
                                                            {ind.indicator}
                                                        </div>

                                                        {/* CHART */}
                                                        <div style={{ display: "flex" }}>

                                                            {/* Y AXIS */}
                                                            <div style={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                justifyContent: "space-between",
                                                                height: "110px",
                                                                fontSize: "9px",
                                                                paddingRight: "4px"
                                                            }}>
                                                                {yAxis.labels.map((label, i) => (
                                                                    <div
                                                                        key={i}
                                                                        style={{
                                                                            height: "25%",
                                                                            display: "flex",
                                                                            alignItems:
                                                                                i === 0
                                                                                    ? "flex-start"
                                                                                    : i === yAxis.labels.length - 1
                                                                                        ? "flex-end"
                                                                                        : "center",
                                                                            // alignItems: i === 0 ? "flex-start" : "center",
                                                                            justifyContent: "flex-end"
                                                                        }}
                                                                    >
                                                                        {label}
                                                                    </div>
                                                                ))}
                                                            </div>

                                                            {/* GRAPH */}
                                                            <div style={{
                                                                position: "relative",
                                                                flex: 1,
                                                                height: "110px",
                                                                width: "150px",
                                                                borderLeft: "1px solid #999",
                                                                borderBottom: "1px solid #999",
                                                                marginLeft: "5px"
                                                            }}>

                                                                {/* Background Zones */}
                                                                {/* <div style={{ position: "absolute", top: 0, width: "100%", height: "33%", background: "#FF0000" }} />
                                                                <div style={{ position: "absolute", top: "33%", width: "100%", height: "34%", background: "#FFC000" }} />
                                                                <div style={{ position: "absolute", bottom: 0, width: "100%", height: "33%", background: "#00B050" }} /> */}

                                                                {zoneConfig.zones.map((zone, i) => {

                                                                    const colors = {
                                                                        red: "#FF0000",
                                                                        amber: "#FFC000",
                                                                        green: "#00B050"
                                                                    };

                                                                    return (
                                                                        <div
                                                                            key={i}
                                                                            style={{
                                                                                position: "absolute",
                                                                                top: `${i * 33.33}%`,
                                                                                width: "100%",
                                                                                height: "33.33%",
                                                                                background: colors[zone]
                                                                            }}
                                                                        />
                                                                    );
                                                                })}
                                                                {/* SVG */}
                                                                <svg
                                                                    width="100%"
                                                                    height="110"
                                                                    viewBox="0 0 260 110"
                                                                    preserveAspectRatio="none"
                                                                    style={{ position: "absolute", top: 0, left: 0 }}
                                                                >

                                                                    {/* LINE */}
                                                                    <polyline
                                                                        points={data.map((d, i) => {

                                                                            const width = 260;
                                                                            const height = 110;

                                                                            const paddingLeft = 10;
                                                                            const paddingRight = 10;
                                                                            const paddingTop = 8;
                                                                            const paddingBottom = 18;

                                                                            const usableWidth = width - paddingLeft - paddingRight;
                                                                            const usableHeight = height - paddingTop - paddingBottom;

                                                                            const x = data.length === 1
                                                                                ? width / 2
                                                                                : paddingLeft + (i / (data.length - 1)) * usableWidth;


                                                                            const y = getYFromStatus(
                                                                                d.value,
                                                                                d.status,
                                                                                yAxis,
                                                                                usableHeight,
                                                                                paddingTop,
                                                                                zoneConfig
                                                                            );

                                                                            return `${x},${y}`;

                                                                        }).join(" ")}
                                                                        fill="none"
                                                                        stroke="#000"
                                                                        strokeWidth="2"
                                                                    />

                                                                    {/* POINTS */}
                                                                    {data.map((d, i) => {

                                                                        const width = 260;
                                                                        const height = 110;

                                                                        const paddingLeft = 10;
                                                                        const paddingRight = 10;
                                                                        const paddingTop = 8;
                                                                        const paddingBottom = 18;

                                                                        const usableWidth = width - paddingLeft - paddingRight;
                                                                        const usableHeight = height - paddingTop - paddingBottom;

                                                                        const x = data.length === 1
                                                                            ? width / 2
                                                                            : paddingLeft + (i / (data.length - 1)) * usableWidth;


                                                                        const y = getYFromStatus(
                                                                            d.value,
                                                                            d.status,
                                                                            yAxis,
                                                                            usableHeight,
                                                                            paddingTop,
                                                                            zoneConfig
                                                                        );

                                                                        return (
                                                                            <circle
                                                                                key={i}
                                                                                cx={x}
                                                                                cy={y}
                                                                                r="3.5"
                                                                                fill={getColor(d.status)}
                                                                                stroke="#000"
                                                                                strokeWidth="0.8"
                                                                            />
                                                                        );
                                                                    })}

                                                                </svg>

                                                                {/* VALUE LABELS */}
                                                                {data.map((d, i) => {

                                                                    const width = 260;
                                                                    const height = 110;

                                                                    const paddingLeft = 10;
                                                                    const paddingRight = 10;
                                                                    const paddingTop = 8;
                                                                    const paddingBottom = 18;

                                                                    const usableWidth = width - paddingLeft - paddingRight;
                                                                    const usableHeight = height - paddingTop - paddingBottom;

                                                                    const x = data.length === 1
                                                                        ? width / 2
                                                                        : paddingLeft + (i / (data.length - 1)) * usableWidth;


                                                                    const y = getYFromStatus(
                                                                        d.value,
                                                                        d.status,
                                                                        yAxis,
                                                                        usableHeight,
                                                                        paddingTop,
                                                                        zoneConfig
                                                                    );

                                                                    //  EDGE HANDLING
                                                                    let transform = "translateX(-50%)"; // default center

                                                                    if (i === 0) {
                                                                        transform = "translateX(0%)";   //  shift right
                                                                    } else if (i === data.length - 1) {
                                                                        transform = "translateX(-100%)"; //  shift left
                                                                    }

                                                                    return (
                                                                        <div title={formatValue(d.value)}
                                                                            key={i}
                                                                            style={{
                                                                                position: "absolute",
                                                                                left: `${(x / width) * 100}%`,
                                                                                top: `${Math.max(6, Math.min(y - 16, 132))}px`,
                                                                                transform,
                                                                                fontSize: "9px",
                                                                                whiteSpace: "nowrap",
                                                                                color: "white",
                                                                                fontWeight: "bold",
                                                                                cursor: "pointer"
                                                                            }}
                                                                        >
                                                                            {formatValue(d.value)}
                                                                        </div>
                                                                    );
                                                                })}

                                                            </div>
                                                        </div>

                                                        {/* X AXIS */}
                                                        <div style={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            marginLeft: "40px",
                                                            fontSize: "9px"
                                                        }}>
                                                            {data.map((d, i) => (
                                                                <div key={i} style={{ whiteSpace: "nowrap" }}>
                                                                    {formatExcelDate(d.date)}
                                                                </div>
                                                            ))}
                                                        </div>

                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>

                            </>
                        )

                    }


                    {viewType === "criticality" && (

                        <div style={{
                            border: "1px solid #2b6cb0",
                            padding: "15px",
                            marginTop: "8px"
                        }}>
                            <div
                                className={`tableWrapper ${tableStyles.tableWrapper}`}
                                style={{
                                    "maxHeight": "435px",   // or any value you want
                                    border: "none"
                                }}
                            >

                                {/* Header */}
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <h6 style={{ marginBottom: "5px" }}>
                                        Risk Indicator Distribution - By Criticality
                                    </h6>


                                </div>

                                <div style={{ fontSize: "11px", marginBottom: "10px" }}>
                                    Displays the number of Risk Indicators in Green, Amber and Red Zones.
                                </div>

                                <div style={{
                                    display: "grid",
                                    gridTemplateColumns: "120px 1fr 1fr 1fr",
                                    gap: "10px",
                                    // cursor:"pointer",
                                    alignItems: "center"
                                }}>

                                    {/* Empty cell */}
                                    <div></div>

                                    {/* Period Headers */}
                                    <div style={{
                                        background: "#1e73be",
                                        color: "white",
                                        fontSize: "12px",
                                        padding: "3px",
                                        textAlign: "center"
                                    }}>
                                        Current Period
                                    </div>

                                    <div style={{
                                        background: "#1e73be",
                                        color: "white",
                                        fontSize: "12px",
                                        padding: "3px",
                                        textAlign: "center"
                                    }}>
                                        Previous Period
                                    </div>

                                    <div style={{
                                        background: "#1e73be",
                                        color: "white",
                                        fontSize: "12px",
                                        padding: "3px",
                                        textAlign: "center"
                                    }}>
                                        Past Period
                                    </div>

                                    {["Level 1", "Level 2A", "Level 2B"].map(level => (

                                        <React.Fragment key={level}>

                                            {/* Level Column */}
                                            <div style={{
                                                background: "#d9e3ef",
                                                padding: "5px",
                                                fontSize: "12px",
                                                cursor: "pointer",
                                                textAlign: "center",
                                                fontWeight: "bold"
                                            }}>
                                                {level}
                                            </div>

                                            {["current", "previous", "past"].map(period => {

                                                const key = `${period}_${level}`;

                                                return (
                                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                                        <canvas
                                                            key={key}
                                                            ref={el => chartRefs.current[key] = el}
                                                            width="90"
                                                            height="90"
                                                            style={{ maxWidth: "90px", maxHeight: "90px", cursor: "pointer" }}
                                                        />
                                                    </div>
                                                );

                                            })}

                                        </React.Fragment>

                                    ))}

                                </div>
                            </div>
                        </div>
                    )}
                    {
                        viewType === "ownership" && selectedOwnership && (

                            <div style={{
                                border: "1px solid #2b6cb0",
                                padding: "15px",
                                marginTop: "8px"
                            }}>
                                <div
                                    className={`tableWrapper ${tableStyles.tableWrapper}`}
                                    style={{
                                        "maxHeight": "435px",   // or any value you want
                                        border: "none"
                                    }}
                                >
                                    {/* Header */}
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        <h6 style={{ marginBottom: "5px" }}>
                                            Risk Indicator Treemap - By {selectedOwnership}
                                        </h6>

                                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>

                                            <label
                                                style={{
                                                    fontSize: "12px",
                                                    fontWeight: "500",
                                                    marginBottom: "0",
                                                    whiteSpace: "nowrap",
                                                    marginRight: "0px"
                                                }}
                                            >
                                                Show By :
                                            </label>
                                            <div className="dropdown" style={{ minWidth: "210px" }}>
                                                <button
                                                    className="btn btn-light btn-sm dropdown-toggle w-100 text-start"
                                                    type="button"
                                                    data-bs-toggle="dropdown"
                                                    style={{
                                                        border: selectedOwnership ? "1px solid #06090e" : "1px solid #ccc",
                                                        padding: "4px 8px",
                                                        fontSize: "12px",
                                                        lineHeight: "1.2"
                                                    }}
                                                >
                                                    {selectedOwnership || "Select Ownership"}
                                                </button>

                                                <ul className="dropdown-menu w-100">

                                                    <div className={`tableWrapper ${tableStyles.tableWrapper}`}
                                                        style={{ maxHeight: "145px", overflowY: "auto", border: "none" }}
                                                    >
                                                        {ownershipList.map(o => (
                                                            <li key={o}>
                                                                <button
                                                                    className="dropdown-item"
                                                                    onClick={() => setSelectedOwnership(o)}
                                                                    style={{
                                                                        padding: "4px 8px",
                                                                        fontSize: "12px"
                                                                    }}
                                                                >
                                                                    {o}
                                                                </button>
                                                            </li>
                                                        ))}
                                                    </div>
                                                </ul>
                                            </div>
                                        </div>

                                    </div>

                                    <div style={{ fontSize: "11px", marginBottom: "10px" }}>
                                        Displays the number of Risk Indicators in Green, Amber and Red Zones by Ownership.
                                    </div>

                                    <div style={{
                                        display: "grid",
                                        gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
                                        gap: "16px",
                                        alignItems: "start"
                                    }}>

                                        {Object.entries(buildOwnershipCounts(selectedOwnership))
                                            .sort((a, b) => new Date(b[0]) - new Date(a[0]))
                                            .slice(0, 4)
                                            .map(([date, data]) => (

                                                <div key={date} style={{
                                                    border: "1px solid #d0d7de",
                                                    borderRadius: "10px",
                                                    overflow: "hidden",
                                                    minHeight: "140px",
                                                    width: "100%",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                                                    background: "#fff"
                                                }}>

                                                    {/* Top Section (Green + Amber) */}
                                                    <div style={{ display: "flex", flex: 2 }}>

                                                        {/* Green */}
                                                        <div
                                                            style={{
                                                                flex: data.green.length || 1,
                                                                background: "#00B050",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                color: "#fff",
                                                                fontWeight: "bold",
                                                                fontSize: "14px",
                                                                cursor: "pointer",
                                                                transition: "0.2s"
                                                            }}
                                                            onClick={() => {
                                                                if (!data.green.length) return;
                                                                setDetailRows(data.green.map(formatRow));
                                                                setDetailTitle(`${selectedOwnership} - ${formatExcelDate(date)} - Green`);
                                                                setShowDetailModal(true);
                                                            }}
                                                        >
                                                            {data.green.length}
                                                        </div>

                                                        {/* Amber */}
                                                        <div
                                                            style={{
                                                                flex: data.amber.length || 1,
                                                                background: "#FFC000",
                                                                display: "flex",
                                                                color: "#fff",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                fontWeight: "bold",
                                                                fontSize: "14px",
                                                                cursor: "pointer"
                                                            }}
                                                            onClick={() => {
                                                                if (!data.amber.length) return;
                                                                setDetailRows(data.amber.map(formatRow));
                                                                setDetailTitle(`${selectedOwnership} - ${formatExcelDate(date)} - Amber`);
                                                                setShowDetailModal(true);
                                                            }}
                                                        >
                                                            {data.amber.length}
                                                        </div>

                                                    </div>

                                                    {/* Red Section */}
                                                    <div
                                                        style={{
                                                            flex: 1,
                                                            background: "#FF0000",
                                                            color: "#fff",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            fontWeight: "bold",
                                                            fontSize: "14px",
                                                            cursor: "pointer"
                                                        }}
                                                        onClick={() => {
                                                            if (!data.red.length) return;
                                                            setDetailRows(data.red.map(formatRow));
                                                            setDetailTitle(`${selectedOwnership} - ${formatExcelDate(date)} - Red`);
                                                            setShowDetailModal(true);
                                                        }}
                                                    >
                                                        {data.red.length}
                                                    </div>

                                                    {/* Footer */}
                                                    <div style={{
                                                        background: "#1e73be",
                                                        color: "#fff",
                                                        textAlign: "center",
                                                        fontSize: "11px",
                                                        padding: "4px",
                                                        letterSpacing: "0.5px"
                                                    }}>
                                                        {formatExcelDate(date)}
                                                    </div>

                                                </div>

                                            ))}
                                    </div>
                                </div>

                            </div>
                        )
                    }

                    {
                        viewType === "dashboard" && (
                            <>
                                <div style={sectionStyle}>
                                    <div
                                        className={`tableWrapper ${tableStyles.tableWrapper}`}
                                        style={{
                                            maxHeight: "unset",
                                            border: "none",
                                            // height: "100%"
                                        }}
                                    >
                                        <div style={{ display: "flex", justifyContent: "space-between" }}>

                                            <h6 style={{ marginBottom: "5px" }}>Critical Risk Indicators</h6>

                                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>

                                                <label
                                                    style={{
                                                        fontSize: "12px",
                                                        fontWeight: "500",
                                                        marginBottom: "0",
                                                        whiteSpace: "nowrap",
                                                        marginRight: "0px"
                                                    }}
                                                >
                                                    Show By :
                                                </label>
                                                <div className="dropdown" style={{ minWidth: "180px" }}>
                                                    <button
                                                        className="btn btn-light btn-sm dropdown-toggle w-100 text-start"
                                                        type="button"
                                                        data-bs-toggle="dropdown"
                                                        style={{
                                                            border: dashboardParameter ? "1px solid #06090e" : "1px solid #ccc",
                                                            padding: "4px 8px",
                                                            fontSize: "12px",
                                                            lineHeight: "1.2"
                                                        }}
                                                    >
                                                        {dashboardParameter || "Select Parameter"}
                                                    </button>

                                                    <ul className="dropdown-menu w-100">

                                                        <div className={`tableWrapper ${tableStyles.tableWrapper}`}
                                                            style={{ maxHeight: "145px", overflowY: "auto", border: "none" }}
                                                        >

                                                            {Object.keys(parameterMap).map(param => (
                                                                <li key={param}>
                                                                    <button
                                                                        className="dropdown-item"
                                                                        onClick={() => setDashboardParameter(param)}
                                                                        style={{
                                                                            padding: "4px 8px",
                                                                            fontSize: "12px"
                                                                        }}
                                                                    >
                                                                        {toProperCase(param)}
                                                                    </button>
                                                                </li>
                                                            ))}
                                                        </div>
                                                    </ul>
                                                </div>

                                            </div>
                                        </div>

                                        <div style={{ fontSize: "11px", marginBottom: "10px" }}>
                                            Displays the Risk Indicators ({dashboardParameter}) marked for CRO Dashboard.
                                            Risk Indicators shows the Current, Past and Previous values and its Status.
                                        </div>
                                        <div
                                            className={`tableWrapper ${tableStyles.tableWrapper}`}
                                            style={{
                                                maxHeight: "unset",
                                                border: "none",
                                                overflowY: "auto",
                                                // height: "calc(100vh - 260px)"
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "grid",
                                                    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 280px))",
                                                    gap: "28px",
                                                    justifyContent: "flex-start"
                                                }}
                                            >
                                                {Object.entries(dashboardData).map(([indicator, data]) => {

                                                    if (!data) return null;

                                                    const current = data?.current;
                                                    const previous = data?.previous;
                                                    const past = data?.past;
                                                    const trend = getTrend(current, previous);

                                                    const formatToDDMonYY = (dateStr) => {
                                                        if (!dateStr) return "-";

                                                        const parts = dateStr.split("-");
                                                        if (parts.length !== 3) return dateStr;

                                                        const [year, month, day] = parts;

                                                        return `${day}-${month}-${year.slice(-2)}`;
                                                    };

                                                    return (

                                                        <div
                                                            key={indicator}
                                                            style={{
                                                                borderBottom: "3px solid #1e73be",
                                                                paddingBottom: "5px",
                                                                borderRadius: "12px",              // ✅ rounded corners
                                                                boxShadow: "0 2px 8px rgba(0,0,0,0.08)", // ✅ soft shadow
                                                                overflow: "hidden",               // ✅ keeps rounded edges clean
                                                                background: "#fff",
                                                                transition: "all 0.2s ease-in-out"
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                e.currentTarget.style.transform = "translateY(-3px)";
                                                                e.currentTarget.style.boxShadow = "0 6px 16px rgba(0,0,0,0.15)";
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                e.currentTarget.style.transform = "none";
                                                                e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)";
                                                            }}
                                                        >

                                                            <div style={{
                                                                background: "linear-gradient(90deg, #1e73be, #4fa3ff)", // ✅ gradient
                                                                color: "white",
                                                                fontSize: "12px",
                                                                padding: "3px",
                                                                textAlign: "center",
                                                                fontWeight: "600",
                                                                letterSpacing: "0.5px"
                                                            }}>
                                                                {data.riskArea}
                                                            </div>

                                                            <div title={indicator}
                                                                style={{
                                                                    background: "#f4f7fb",
                                                                    fontSize: "12px",
                                                                    textAlign: "center",
                                                                    padding: "3px",
                                                                    fontWeight: "500",
                                                                    whiteSpace: "nowrap",        //  prevent line break
                                                                    overflow: "hidden",          //  hide overflow
                                                                    textOverflow: "ellipsis",     //  show ...
                                                                    cursor: "pointer"
                                                                }}>
                                                                {indicator}
                                                            </div>

                                                            <div style={{
                                                                background: "#ffffff",
                                                                fontSize: "12px",
                                                                textAlign: "center"
                                                            }}>
                                                                {formatToDDMonYY(current?.["Reporting Date"])}
                                                            </div>

                                                            <div style={{
                                                                background: getColor(current?.["Current Status"]),
                                                                textAlign: "center",
                                                                fontWeight: "bold",
                                                                fontSize: "16px",
                                                                color: "white",              // bigger
                                                                // padding: "6px 0",
                                                                borderRadius: "6px",           // slight rounding
                                                                margin: "2px"
                                                            }}>
                                                                {formatValue(current?.["Current Value"])}
                                                            </div>


                                                            <div style={{ display: "flex", fontSize: "12px" }}>

                                                                {/* Previous */}
                                                                <div style={{ flex: 1, textAlign: "center" }}>
                                                                    {formatToDDMonYY(previous?.["Reporting Date"])}
                                                                    <div style={{
                                                                        background: getColor(previous?.["Current Status"]),
                                                                        margin: "1px 4px",
                                                                        borderRadius: "20px",   // pill shape
                                                                        color: "white",
                                                                        padding: "2px 6px",
                                                                        fontWeight: "bold"
                                                                    }}>
                                                                        {previous ? formatValue(previous["Current Value"]) : "-"}
                                                                    </div>
                                                                </div>

                                                                {/* Past */}
                                                                <div style={{ flex: 1, textAlign: "center" }}>
                                                                    {formatToDDMonYY(past?.["Reporting Date"])}
                                                                    <div style={{
                                                                        background: getColor(past?.["Current Status"]),
                                                                        margin: "1px 4px",
                                                                        borderRadius: "20px",   //  pill shape
                                                                        color: "white",
                                                                        padding: "2px 6px",
                                                                        fontWeight: "bold"
                                                                    }}>
                                                                        {past ? formatValue(past["Current Value"]) : "-"}
                                                                    </div>
                                                                </div>

                                                                <div style={{ flex: 1, textAlign: "center" }}>
                                                                    Trend
                                                                    <div
                                                                        style={{
                                                                            fontSize: "16px",
                                                                            fontWeight: "bold",
                                                                            color:
                                                                                trend === "up"
                                                                                    ? "#00B050"
                                                                                    : trend === "down"
                                                                                        ? "#FF0000"
                                                                                        : "#999999",
                                                                            fontWeight: "bold",
                                                                            animation: trend === "up" || trend === "down"
                                                                                ? "trendBlink 1s infinite"
                                                                                : "none"
                                                                        }}
                                                                    >
                                                                        {trend === "up" && "▲"}
                                                                        {trend === "down" && "▼"}
                                                                        {trend === "same" && "—"}
                                                                        {!trend && "-"}
                                                                    </div>

                                                                    <style>
                                                                        {`
        @keyframes trendBlink {
            0% { opacity: 1; transform: scale(1); }
            50% { opacity: 0.4; transform: scale(1.25); }
            100% { opacity: 1; transform: scale(1); }
        }
        `}
                                                                    </style>

                                                                </div>

                                                            </div>

                                                        </div>
                                                    );
                                                })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </>

                        )
                    }
                </div>

            </main >

            <Footer />

        </div >


    );

}

export default GapsyCRODashboard;